import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { FooterComponent } from './footer/footer.component';
import { LoggedUserComponent } from './loggeduser.component';
import { MenuListItemComponent } from './menu-list-item/menu-list-item.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import {SharedModule} from "../shared/shared.module";
import { LoggedUserRoutesModule } from './logged-user.routes.module';
import {HeaderComponent} from "./header/header.component";
import {MatMenuModule} from "@angular/material/menu";
import {TranslocoModule} from "@ngneat/transloco";


@NgModule({
  declarations: [LoggedUserComponent, SidebarComponent, FooterComponent, MenuListItemComponent, HeaderComponent],
    imports: [
        CommonModule,
        SharedModule,
        LoggedUserRoutesModule,
        MatListModule,
        MatMenuModule,
      TranslocoModule
    ],
  // providers: [
  //   {
  //     provide: MatPaginatorIntl,
  //     useFactory: (translate) => {
  //       const service = new PaginatorIntlService();
  //       service.injectTranslateService(translate);
  //       return service;
  //     },
  //     deps: [TranslateService]
  //   },
  // ],
})
export class LoggeduserModule { }
